import { Form } from 'antd';
import React, { memo } from 'react';
import { WorkOrderRecordType } from '@xbcb/shared-types';
import LineItem from 'components/LineItemV2';
import { CommercialInvoiceBaseProps } from 'types';

export interface LineItemsV2Props extends CommercialInvoiceBaseProps {
  keyRef: React.MutableRefObject<string>;
  linesKey?: string;
  required?: boolean;
}

/**
 * LineItemsV2
 *
 * List of LineItems for a commercial invoice product.
 */

export const LineItemsV2: React.FC<LineItemsV2Props> = ({
  localNamePath,
  fullNamePath,
  workOrderType,
  keyRef,
  readOnly,
  disabled,
  linesKey = 'lines',
  required,
}) => {
  const linesNamePath = [...fullNamePath, linesKey];
  const isPsc =
    workOrderType === WorkOrderRecordType.US_POST_SUMMARY_CORRECTION;
  return (
    <Form.List name={[...localNamePath, linesKey]} minimum={1}>
      {(fields) => (
        <>
          {fields.map((field, index) => {
            return (
              <LineItem
                key={field.key}
                index={index}
                fullNamePath={[...linesNamePath, index]}
                localNamePath={[field.name]}
                workOrderType={workOrderType}
                keyRef={keyRef}
                readOnly={readOnly}
                disabled={disabled}
                required={required ?? !isPsc}
              />
            );
          })}
          {/* Removed per Project Nacrene UAT feedback 7/2024. Can delete after launch if confirmed this feature isn't needed. */}
          {/* <StyledButton hidden={disabled} onClick={() => add({})}>
            Add Line
          </StyledButton> */}
        </>
      )}
    </Form.List>
  );
};

export default memo(LineItemsV2);
